import React, { useCallback } from "react"
import { Translate } from "utils/i18n-shim"
import { openDialog } from "./store"

export const useEditActivityEventAction = () => {
  return useCallback((activityEvent, japCustomerId) => {
    return {
      label: <Translate value="edit" />,
      onClick: () => openDialog({ activityEvent, japCustomerId })
    }
  }, [])
}
